/**
 * Centralized auth access.
 * Main app: httpOnly cookies (no JS access needed — cookies sent automatically)
 * Partner portal: uses in-memory token store with sessionStorage fallback
 */

// In-memory token store for partner portal sessions
let _partnerToken = null;
let _partnerUser = null;

export const getAuthToken = () => {
  if (_partnerToken) return _partnerToken;
  return sessionStorage.getItem('partner_session');
};

export const setAuthToken = (token) => {
  _partnerToken = token;
  sessionStorage.setItem('partner_session', token);
};

export const getStoredUser = () => {
  if (_partnerUser) return _partnerUser;
  try {
    const raw = sessionStorage.getItem('partner_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setStoredUser = (user) => {
  _partnerUser = user;
  sessionStorage.setItem('partner_user', JSON.stringify(user));
};

export const clearAuth = () => {
  _partnerToken = null;
  _partnerUser = null;
  sessionStorage.removeItem('partner_session');
  sessionStorage.removeItem('partner_user');
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
